import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  onCambioMoneda,
  calcularTotales,
  round,
  validarCantidad,
  comboprecios,
} from "../../util/varios";
import moment from "moment";

import useTableScroll from "../useTableScroll";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoProducto from "../../catalogos/catalogoProducto";
import RegistrarProveedor from "../../catalogos/catalogoAgregarProveedor";
import CatalogoOrdenes from "../../catalogos/catalogoOrdenes";

const TablapServicios = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  let idagente = JSON.parse(sessionStorage.getItem("idagente"));
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accgservicios = JSON.parse(
    sessionStorage.getItem("accgserviciosc")
  );


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtNombreCliente = useRef();
  const txtDescuento = useRef();
  const txtSubTotal = useRef();
  const txtTotalIva = useRef();
  const txtExentoTotal = useRef();
  const txtTotal = useRef();
  const txtDirClient = useRef();
  const txtCedRifv = useRef();
  const txtNombreVendedor = useRef();
  const txtCantidad = useRef([]);
  const txtPrecio = useRef([]);
  const txtId = useRef([]);
  const txtIdalmacen = useRef();
  const txtCedRif = useRef();
  const txtCodigo = useRef();
  const txtNumPresupuesto = useRef();
  const txtFecha = useRef();
  const txtFechaVencimiento = useRef();
  const txtIdmovil = useRef();
  const txtIdmoneda = useRef();
  const txtTipoOrdenCompra = useRef();
  const txtFormaPago = useRef();
  const txtOpeInventario = useRef();

  const [idCliente, setIdCliente] = useState("");
  const [idVendedor, setIdVendedor] = useState("");
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [desde, setDesde] = useState(0);
  const [catalogoPresu, setCatalogoPresu] = useState(false);
  const [tituloHeader, setTituloHeader] = useState(
    "Servicios."
  );
  const [numNota, setNumNota] = useState("");
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [numval, setNumval] = useState("");
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [tasaor, setTasaor] = useState(0);
  const [idmoney, setIdmoney] = useState(0);
  const [records, setRecords] = useState([]);
  const [idalmacen, setIdalmacen] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [indice, setIndice] = useState(null);
  const [body, setBody] = useState(null);
  const [catregistrarcliente, setCatregistrarcliente] = useState(false);
  const [combomoneda, setComboMoneda] = useState([]);
  const [almacen, setAlmacen] = useState([]);
  const [moviles, setMoviles] = useState([]);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [valparametro, setValparametro] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [fechav, setFechav] = useState(0);
  const [activate, setActivate] = useState(false);
  const [castabla, setCastabla] = useState(true);
  const [esmovil, setEsmovil] = useState(true);

  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });
  const [acpt, setAcpt] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [vendedor, setVendedor] = useState({
    idvendedor: "",
    tiporif: "J",
    rif: "",
    nombre: "",
    idalmacen: "",
  });
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });

  let nomtabla;

  if (operacion === 4) {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "40px" },
      { label: "PRODUCTO", textAlign: "center", width: "100px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "IVA.", textAlign: "center", width: "50px" },
      { label: "MONTO", textAlign: "center", width: "50px" },
      {
        label: "",
        textAlign: "center",
        width: "20px",
      },
    ];
  } else {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "40px" },
      { label: "PRODUCTO", textAlign: "center", width: "100px" },
      { label: "EXISTENCIA", textAlign: "center", width: "30px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "IVA.", textAlign: "center", width: "50px" },
      { label: "MONTO", textAlign: "center", width: "50px" },
      {
        label: <i className="fas fa-trash" />,
        textAlign: "center",
        width: "20px",
      },
    ];
  }

  const headCells = nomtabla;
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarAgente = () => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idagente}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNombreVendedor.current.value = response.data.nombre;
            txtCedRifv.current.value = response.data.rif;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAlmacen = () => {
    let campos = "*";
    let nomtab = "almacen";
    let orden = "idalmacen";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setAlmacen(response.data);
          } else {
            setAlmacen([]);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Almacen de venta",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setTituloHeader("Servicios.");
    setFechav(0);
    setTasaor(0);
    setHabilitadoProductos(true);
    setAlmacen([]);
    setMoviles([]);
    setVendedor({
      idvendedor: "",
      tiporif: "J",
      rif: "",
      nombre: "",
      idalmacen: "",
    });
    setNumval("");
    txtId.current.value = "";
    txtNombreCliente.current.value = "";
    txtNombreVendedor.current.value = "";
    txtCedRif.current.value = "";
    txtCedRifv.current.value = "";
    txtDirClient.current.value = "";
    txtTotal.current.value = "";
    txtTotalIva.current.value = "";
    txtSubTotal.current.value = "";
    txtCodigo.current.value = "";
    txtFecha.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    txtFormaPago.current.value = "3";
    txtTipoOrdenCompra.current.value = "1";
    setActivate(false);
    setRecords([]);
    setIndice(null);
    setAcpt(false);
    setComboMoneda([]);
    setHabilitarCat(true);
    setNumNota("");
    setVisibleBtn("visible");
    setCastabla(true);
    setOperacion(0);
    setHabilitado(true);
    setHabilitadoNU(false);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: false,
      cancelar: false,
      catalogo: true,
      catalogoper: true,
    });
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        txtIdmoneda.current.selectedIndex = i;
      }
    }

    setTotales({
      subtotal: 0.0,
      descuento: 0.0,
      exento: 0.0,
      sujeto: 0.0,
      iva: 16.0,
      totaliva: 0.0,
      total: 0.0,
    });
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (txtTipoOrdenCompra.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Tipo de Orden no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtTipoOrdenCompra.current.focus();
    } else if (txtFormaPago.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Forma de Pago no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtFormaPago.current.focus();
    } else if (
      txtCedRif.current.value.trim() === "" ||
      txtNombreCliente.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Proveedor",
        icono: "informacion",
      });
      sigue = false;
      txtCedRif.current.focus();
    } else if (
      txtCedRifv.current.value === "" ||
      txtCedRifv.current.value.trim() === "" ||
      txtNombreVendedor.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Vendedor",
        icono: "informacion",
      });
      sigue = false;
      txtCedRifv.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancela.current.focus();
    }

    if (sigue) {
      var orden = [];
      var ordendeta = [];
      var tasa = 0.0;
      var opeinv = [];
      var opeinvdet = [];

      tasa = monedaSub.valormoneda;

      orden.push({
        idorden: operacion === 1 ? 0 : txtCodigo.current.value,
        numorden: numNota,
        cedularif: txtCedRif.current.value,
        descripcion: txtTipoOrdenCompra.current.value === "1" ? "VENTA DE PRODUCTOS" : "ORDEN DE SERVICIO",
        totalmonto: totales.total,
        totaliva: totales.totaliva,
        totaldescuento: totales.descuento,
        totalsujeto: totales.sujeto,
        totalexento: totales.exento,
        idcliente: idCliente,
        idvendedor: operacion === 1 ? idagente : idVendedor,
        fecha: txtFecha.current.value,
        status: 0,
        idmoneda: monedaSub.idmoneda,
        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
        tipoorden: txtTipoOrdenCompra.current.value,
        formapago: txtFormaPago.current.value,
        fechavence:
          txtFormaPago.current.value === "4"
            ? txtFechaVencimiento.current.value
            : null,
        valormoneda: tasa,
        idmovil: txtTipoOrdenCompra.current.value === "1" ? null : txtIdmovil.current.value
      });

      opeinv.push({
        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
        tipooperacion: "SALIDA",
        idalmacenorigen: txtIdalmacen.current.value,
        idalmacendestino: "",
        fecha: txtFecha.current.value,
        idmoneda: monedaSub.idmoneda,
        observacion: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "ORDEN DE SERVICIO",
      });

      for (let i = 0; i < records.length; i++) {
        ordendeta.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          iva: records[i].iva,
          punitario: records[i].precio,
          descuento: "0.00",
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tasa: monedaSub.valormoneda,
          codproducto: records[i].codigo,
          costo: records[i].costocalculado,
          utilidad: records[i].utipreciomaxi,
          tipopreciodeta: records[i].tipoprecio,
          idalmacen: records[i].idalmacen
        });

        opeinvdet.push({
          idproducto: records[i].idproducto,
          nombre: records[i].nombrecorto,
          cantidad: records[i].cantidad,
          precio: records[i].precio,
          fechavencimiento: txtFormaPago.current.value === "4"
            ? txtFechaVencimiento.current.value
            : null,
          tipomovimiento: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "SERVICIO",
          fechatipomovimiento: txtFecha.current.value,
          numfactura: numNota,
          idalmacen: records[i].idalmacen,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tipofactor: records[i].tipofactor,
          valorfactor: records[i].valorfactor,
          tasa: monedaSub.valormoneda,
        });
      }

      setBody({
        orden: orden,
        ordendeta: ordendeta,
        idtipopeinv: "2",
        opeinv: opeinv,
        opeinvdet: opeinvdet,
      });

      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "¿Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "¿Esta Seguro de Modificar estos Datos?.";
      } else if (operacion === 3) {
        msg = "¿Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/servicios/actualizarordenes/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idord + " Creado Correctamente!",
              icono: "exito",
            });
            /* window.open(op.reportes + "reporte=Pedido" + "&CODIGO=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"); */
            if (txtFormaPago.current.value === "4") {
              txtFechaVencimiento.current.value =
                moment(fechaSistema).format("YYYY-MM-DD");
            }
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " +
                response.data.idord +
                " Modificado Correctamente!",
              icono: "exito",
            });
            if (txtFormaPago.current.value === "4") {
              txtFechaVencimiento.current.value =
                moment(fechaSistema).format("YYYY-MM-DD");
            }
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "¡Registro " + response.data.idord + " Eliminado Correctamente!",
              icono: "exito",
            });
          }

          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      var prod = records;
      setDesde(0);
      setRecords(prod);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
  };

  const seleccionarProducto = (index, idubi, idprod) => {
    let endpoint = `${op.conexion
      }/api/inventario/seleccionarproductoinv?idproducto='${idprod.toUpperCase()}'&idalmacen=${idubi}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];
          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "no existe un producto con ese codigo en el almacen.",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "el producto ya ha sido seleccionado.",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];
              let precio = 0.0;
              let montoiva = 0.0;
              let cantie = response.data.cantidad;
              let tipouni = 0;
              let tiene_iva = false;
              let tipoprecio = parseInt(response.data.tipoprecio);

              if (parseFloat(response.data.ivaventa) > 0.0) {
                tiene_iva = true;
              }

              if (
                parseInt(response.data.tipofactor) === 0 ||
                response.data.tipofactor === null
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);

                if (tipoprecio === 1) {
                  precio = parseFloat(response.data.preciomaxi);
                } else if (tipoprecio === 2) {
                  precio = parseFloat(response.data.precioofe);
                } else if (tipoprecio === 3) {
                  precio = parseFloat(response.data.preciomayor);
                } else if (tipoprecio === 4) {
                  precio = parseFloat(response.data.preciomini);
                }

                /* precio =
                  response.data.costocalculado *
                  (1 + response.data.utipreciomaxi / 100);
                precio = Math.round(precio * 100) / 100; 

                montoiva = (precio * response.data.ivaventa) / 100;*/
              } else {
                if (
                  response.data.idunidadventa === response.data.idunidadalterna
                ) {
                  tipouni = 1;
                  uni = [
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                  ];

                  cantie = parseFloat(response.data.cantidad);
                  cantie = Math.trunc(cantie);
                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxialter);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofealter);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayoralter);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciominialter);
                  }

                  /*                   precio =
                    response.data.costocalculadoalter *
                    (1 + response.data.utipreciomaxialter / 100);
                  precio = Math.round(precio * 100) / 100;

                  montoiva = (precio * response.data.ivaventa) / 100; */
                } else if (
                  response.data.idunidadventa === response.data.idunidadmedida
                ) {
                  tipouni = 0;
                  uni = [
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                  ];

                  cantie = parseFloat(
                    response.data.cantidad / response.data.valorfactor
                  );
                  cantie = Math.trunc(cantie);

                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxi);
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofe);
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayor);
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciomini);
                  }

                  /*precio =
                    response.data.costocalculado *
                    (1 + response.data.utipreciomaxi / 100);
                  precio = Math.round(precio * 100) / 100;

                  montoiva = (precio * response.data.ivaventa) / 100; */
                }
              }

              if (index !== null) {
                data[index] = {
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciobs: 0.0,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  iva: response.data.ivaventa,
                  montoiva: montoiva,
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idalmacen: response.data.idalmacen,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: response.data.tipoprecio,
                };
              } else {
                data.push({
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  preciobs: 0.0,
                  iva: response.data.ivaventa,
                  montoiva: montoiva,
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idalmacen: response.data.idalmacen,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: response.data.tipoprecio,
                });
              }

              setRecords(data);
              setTotales(calcularTotales(data));
              setIndice(index);

              if (index !== null) {
                setTimeout(() => txtCantidad.current[index].focus(), 300);
              } else {
                setTimeout(
                  () => txtCantidad.current[data.length - 1].focus(),
                  300
                );
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (idorden) => {
    let nomtab1 = "ordenes_detalle";
    let nomtab2 = "ordenes";
    let nomid = "idorden";
    let endpoint = `${op.conexion}/api/servicios/seleccionarordenesdet?id=${idorden}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {

            let prod = [];
            let uni = [];
            let montoiva = 0.0;
            let cantie = 0.0;
            let cantiea = 0.0;
            let tipouni = 0;
            let tiene_iva = false;

            for (let i = 0; i < response.data.length; i++) {
              if (parseFloat(response.data[i].iva) > 0.0) {
                tiene_iva = true;
              }
              if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) <= 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              } else if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) > 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);

                cantiea = cantiea * parseFloat(response.data[i].valorfactor);
                cantiea = Math.trunc(cantiea);
              } else if (response.data[i].tipounidad === 1) {
                tipouni = 1;
                uni = [
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              }

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                cantidadE: parseFloat(cantie),
                cantidadEA: parseFloat(cantiea),
                nombrecorto: `${response.data[i].nombrecorto} ${tiene_iva ? "" : " (E)"
                  }`,
                precio: response.data[i].punitario,
                preciobs: response.data[i].punitariobs,
                preciomaxi: response.data[i].preciomaxi,
                precioofe: response.data[i].precioofe,
                preciomayor: response.data[i].preciomayor,
                preciomini: response.data[i].preciomini,
                preciomaxialter: response.data[i].preciomaxialter,
                precioofealter: response.data[i].precioofealter,
                preciomayoralter: response.data[i].preciomayoralter,
                preciominialter: response.data[i].preciominialter,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                montoiva: response.data[i].cantidad * montoiva,
                descuento: response.data[i].descuento,
                total: response.data[i].cantidad * response.data[i].punitario,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: tipouni,
                valormoneda: monedaCambio.valormoneda,
                idmoneda: response.data[i].idmoneda,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
                tipoprecio: response.data[i].tipopreciodeta,
              });
            }

            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const agregarProducto = (producto) => {
    setMostrar(false);
    seleccionarProducto(indice, txtIdalmacen.current.value, producto.codigo);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accgservicios &&
        accgservicios.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("hidden");
        setHabilitadoProductos(false);
        setTituloHeader("Incluir Servicio.");
        setHabilitado(false);
        seleccionarMonedas();
        seleccionarAgente();
        seleccionarAlmacen();
        setCastabla(false);
        setOperacion(1);
        setAcpt(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accgservicios &&
        accgservicios.toString().substring(1, 2) === "1"
      ) {
        setTituloHeader("Editar Servicio.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        seleccionarMonedas();
        setCatalogoPresu(true);
        seleccionarAlmacen();
        setHabilitarCat(false);
        setCastabla(false);
        setAcpt(false);
        setOperacion(2);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accgservicios &&
        accgservicios.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Servicio.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        setCatalogoPresu(true);
        seleccionarMonedas();
        setAcpt(false);
        setHabilitarCat(false);
        setCastabla(true);
        setOperacion(3);
        seleccionarAlmacen();
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accgservicios &&
        accgservicios.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Servicio.");
        setVisibleBtn("hidden");
        seleccionarMonedas();
        setAcpt(true);
        setHabilitado(true);
        setCastabla(true);
        setOperacion(4);
        setHabilitarCat(false);
        setHabilitadoNU(true);
        setDesde(7);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setIdmoney(response.data[i].idmoneda);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
          }
          setTimeout(() => (txtIdmoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarRegistro = () => {
    let campos = "*";
    let nomtab = "ordenes";
    let nomid = "idorden";
    let id = txtCodigo.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setTasaor(response.data.tasa);
            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            setNumNota(response.data.numorden);
            txtCedRif.current.value = response.data.cedularif;
            txtOpeInventario.current.value = response.data.idoperacioninventario;
            txtTipoOrdenCompra.current.value = parseInt(
              response.data.tipoorden
            );
            txtFormaPago.current.value = parseInt(response.data.formapago);
            if (parseInt(response.data.formapago) === 4) {
              setFechav(1);
              txtFechaVencimiento.current.value = moment(
                response.data.fechavence
              ).format("YYYY-MM-DD");
            } else {
              setFechav(0);
            }

            //seleccionarMoneda(response.data.idmoneda);
            seleccionarDetalle(response.data.idorden);

            setTotales({
              subtotal: response.data.totalmonto - response.data.totaliva,
              descuento: response.data.totaldescuento,
              exento: response.data.totalexento,
              sujeto: response.data.totalsujeto,
              iva: 16.0,
              totaliva: response.data.totaliva,
              total: response.data.totalmonto,
            });

          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtCodigo.current.value = "";
            txtCodigo.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idordendecompra") {
          seleccionarRegistro();
        }
      }
    }
  };

  const onCatalogoPresupuesto = (values) => {
    setCatalogoPresu(false);
    txtCodigo.current.value = values.idorden;
    seleccionarRegistro();
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: records,
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    setRecords(cambio.data);
  };


  const imprimirOrdendeCompra = () => {
    if (
      accgservicios &&
      accgservicios.toString().substring(4, 5) === "1"
    ) {
      if (txtCodigo.current.value !== "") {
        let id = txtCodigo.current.value;
        window.open(
          op.reportes + "reporte=Ordencompra" + "&CODIGO=" + id,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  const onChange = (e) => {

    if (e.target.name === "almacen") {
      setIdalmacen(e.target.value);
    }

  }

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-8 mx-auto py-2 card shadow ">
            <div
              className="col-md-12 row border-azul mx-auto justify-content-between rounded py-2"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light d-flex align-items-center">
                <div className="col-md-5">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-md-1 ml-auto">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>

              <div className="col-md-12 row px-0 m-0">
                <div className="col-pd-220 mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CODIGO:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      name="idordendecompra"
                      onKeyUp={handleInputNumeroChange}
                      disabled={habilitado}
                      ref={txtCodigo}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      type="button"
                      onClick={() => setCatalogoPresu(true)}
                      disabled={habilitarCat}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="col-pd-330 mb-1 mx-auto px-0">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO DE MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm form-select fw-bold fs-6"
                      disabled={
                        operacion === 3 || operacion === 0 ? true : false
                      }
                      ref={txtIdmoneda}
                      onChange={onChangeMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={index}>
                            {" "}
                            {`${item.descripcion} ${item.simbolo
                              } ${formatMoneda(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-2 mb-1">
                  <div className="input-group input-group-sm">
                    <select
                      className="form-control form-control-sm form-select fw-bold fs-6"
                      disabled={true}
                      name="almacen"
                      ref={txtIdalmacen}
                      onChange={onChange}
                    >
                      {almacen &&
                        almacen.map((item, index) => (
                          <option key={index} value={item.idalmacen}>
                            {" "}{`${item.descripcion}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <input type="hidden" ref={txtOpeInventario} />

                <div className="col-pd-220 ml-auto mb-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={castabla}
                      className="form-control text-uppercase fs-6"
                      ref={txtFecha}
                      aria-label="Sizing example input"
                      defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-12 mb-2 py-1">
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <div className="col-md-12 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE:{" "}
                      </label>
                      <textarea
                        autoComplete="off"
                        type="text"
                        disabled={habilitado}
                        style={{ height: '40px' }}
                        ref={txtCedRif}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>

                  <div className="col-pd-100 px-2 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        IVA:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={habilitado}
                        ref={txtDirClient}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        MONTO:{" "}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        disabled={habilitado}
                        ref={txtDirClient}
                        className="form-control bg-transparent fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 row m-0 px-0">
                <div className="col-lg-8 mt-auto">
                  {visibleBtn === "visible" ? (
                    <div className="col-pd-botones">
                      <div className="col-md-12 row m-0">
                        <button
                          disabled={botones.incluir}
                          onClick={onBotones(1)}
                          className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                          title="Incluir Almacen"
                        >
                          <i className="fas fa-plus"> Incluir </i>{" "}
                        </button>
                        <button
                          disabled={botones.consultar}
                          onClick={onBotones(4)}
                          className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                          title="Consultar Almacen"
                        >
                          <i className="fas fa-eye"> Consultar</i>{" "}
                        </button>
                        <button
                          disabled={botones.modificar}
                          onClick={onBotones(2)}
                          className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                          title="Modificar Almacen"
                        >
                          <i className="fa fa-edit"> Modificar</i>{" "}
                        </button>
                        <button
                          disabled={botones.eliminar}
                          onClick={onBotones(3)}
                          className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                          title="Eliminar Almacen"
                        >
                          <i className="fa fa-trash"> Eliminar</i>{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-pd-360 row m-0 ml-auto">
                      {habilitadoNU === true ? (
                        <button
                          ref={btnAcepta}
                          onClick={imprimirOrdendeCompra}
                          disabled={
                            txtCodigo.current.value !== "" ? false : true
                          }
                          className="btn btn-sm rounded-pill col ml-1 btn-primary"
                        >
                          <i className="fas fa-print"> Imprimir</i>
                        </button>
                      ) : (
                        ""
                      )}
                      <button
                        ref={btnAcepta}
                        disabled={acpt}
                        onClick={onChangeValidar}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        ref={btnCancela}
                        onClick={onBotones(6)}
                        className="btn btn-danger col ml-1 btn-sm rounded-pill"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoProducto
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
      />

      <CatalogoOrdenes
        show={catalogoPresu}
        ope={operacion}
        onHideCancelar={() => setCatalogoPresu(false)}
        onHideAceptaCatalogo={onCatalogoPresupuesto}
      />


      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablapServicios;



// WEBPACK FOOTER //
// ./src/components/servicios/tablaServicios.js